import {ApiClientInterface} from "./clients";
import {MessageForm} from "./models";

export class ChatManager {
  constructor(private readonly apiClient: ApiClientInterface) {
  }

  public async sendMessageForm(form: MessageForm): Promise<void> {
    return this.apiClient.post("/send", {form});
  }
}